export class Permission {
	public keyCloakUserId: string;
	public firstName: string;
	public lastName: string;
	public email?: string;
	public authCode: string;
	public createDate: string;
	public codeValidUntil?: string;
	public permissionUserId: string;
	public permissionCreatorId: string;
	public tenantUnitId: string;
	public comment?: string;
	public codeActivatedOn?: string;
	public permissionType?: string;
	public area: number;

	constructor(
		keyCloakUserId: string,
		firstName: string,
		lastName: string,
		authCode: string,
		createDate: string,
		permissionType: string,
		permissionUserId: string,
		permissionCreatorId: string,
		tenantUnitId: string,
		area: number,
		mail?: string,
		comment?: string,
		codeActivatedOn?: string,
		codeValidUntil?: string
	) {
		this.keyCloakUserId = keyCloakUserId;
		this.firstName = firstName;
		this.lastName = lastName;
		this.email = mail;
		this.area = area;
		this.comment = comment;
		this.permissionUserId = permissionUserId;
		this.permissionCreatorId = permissionCreatorId;
		this.authCode = authCode;
		this.codeActivatedOn = codeActivatedOn;
		this.codeValidUntil = codeValidUntil;
		this.tenantUnitId = tenantUnitId;
		this.createDate = createDate;
		this.permissionType = permissionType;
	}
}
